import React from 'react'

import { ResponsivePie } from '@nivo/pie'
import { Datum } from '@modules/requirements/client-audit-stats.consts'

type Props = {
  data: Datum[]
}

export function ClientAuditStatsChart(props: Props) {
  return (
    <div style={{ height: 220, width: 220 }}>
      <ResponsivePie
        data={props.data}
        margin={{ bottom: 20 }}
        colors={{ datum: 'data.color' }}
        borderWidth={1}
        borderColor={{ from: 'color', modifiers: [['darker', 0.2]] } as any}
        enableArcLabels={false}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor="#333333"
        enableArcLinkLabels={false}
        isInteractive={false}
      />
    </div>
  )
}
